import { render, staticRenderFns } from "./WorkforcePlanningTargetModal.vue?vue&type=template&id=67cb36b0&scoped=true&"
import script from "./WorkforcePlanningTargetModal.vue?vue&type=script&lang=js&"
export * from "./WorkforcePlanningTargetModal.vue?vue&type=script&lang=js&"
import style0 from "./WorkforcePlanningTargetModal.vue?vue&type=style&index=0&id=67cb36b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cb36b0",
  null
  
)

export default component.exports